module.exports = __webpack_public_path__ + "img/amazon-registry.f2c6a383.png";